import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { DropdownModule, CalendarModule } from 'primeng/primeng';

import { DropdownModule } from "primeng/dropdown";
import { CalendarModule } from "primeng/calendar";
import { TooltipModule } from "primeng/tooltip";
import { ToastModule } from "primeng/toast";
import { MultiSelectModule } from "primeng/multiselect";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ProgressBarModule } from "primeng/progressbar";
import { AutoCompleteModule } from "primeng/autocomplete";
import { StepsModule } from "primeng/steps";
import { TabMenuModule } from "primeng/tabmenu";
import { AccordionModule } from "primeng/accordion";
import { RadioButtonModule } from "primeng/radiobutton";
import { CheckboxModule } from "primeng/checkbox";
import { TreeModule } from "primeng/tree";
import { TabViewModule } from "primeng/tabview";
import { PanelModule } from "primeng/panel";
import { MenuModule } from "primeng/menu";
import { SelectButtonModule } from "primeng/selectbutton";
import { InputSwitchModule } from "primeng/inputswitch";
import { ToggleButtonModule } from "primeng/togglebutton";
import { UploadProgressComponent } from "../shared-components/upload-progress/upload-progress.component";
import { HeaderComponent } from "../shared-components/header/header.component";

@NgModule({
  declarations:[],

  imports: [
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    BrowserAnimationsModule,
    DropdownModule,
    CalendarModule,
    TooltipModule,
    MultiSelectModule,
    ScrollPanelModule,
    ProgressBarModule,
    AutoCompleteModule,
    ToastModule,
    StepsModule,
    TabMenuModule,
    RadioButtonModule,
    CheckboxModule,
    AccordionModule,
    TreeModule,
    TabViewModule,
    PanelModule,
    MenuModule,
    SelectButtonModule,
    InputSwitchModule,
    ToggleButtonModule,
    
  ],
  exports: [
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    BrowserAnimationsModule,
    DropdownModule,
    CalendarModule,
    TooltipModule,
    MultiSelectModule,
    ScrollPanelModule,
    ProgressBarModule,
    AutoCompleteModule,
    ToastModule,
    StepsModule,
    TabMenuModule,
    RadioButtonModule,
    CheckboxModule,
    AccordionModule,
    TreeModule,
    TabViewModule,
    PanelModule,
    MenuModule,
    SelectButtonModule,
    InputSwitchModule,
    ToggleButtonModule,
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class PrimeNGModule {}
